import React from 'react'
import {QueryClientProvider} from '@tanstack/react-query'
import {Routers} from './routes'
import {queryClient} from './queryClient'
import './assets/styles/base.scss'

export const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <Routers />
  </QueryClientProvider>
)
